import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { deleteChannel, fetchChannelList } from "../actions/channel";
import { useSelector } from "react-redux";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { useTranslation } from "react-i18next";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { toast } from "react-toastify";
import { statusRender } from "../utils/cellRenderTable";
import { createDateColumn } from "../utils/agGridDateColumn";

const ChannelList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { channelList } = useSelector((state) => state.channelReducer);

  //breadcrumb
  const translateModule = "channel";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchChannelList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/channel-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(deleteChannel(pageId));
  };

  const columnDefs = [
    {
      headerName: "Naziv kanala",
      field: "name",
      flex: 1,
      minWidth: 180,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Vlasnik kanala",
      field: "ownerFirstName",
      flex: 1,
      minWidth: 180,
      filter: "agTextColumnFilter",
      valueGetter: (params) => {
        const first = params.data?.ownerFirstName || "";
        const last = params.data?.ownerLastName || "";
        return `${first} ${last}`.trim();
      },
      filterValueGetter: (params) => {
        const first = params.data?.ownerFirstName || "";
        const last = params.data?.ownerLastName || "";
        return `${first} ${last}`.trim();
      },
    },

    {
      headerName: "JWPlayer video",
      field: "coverVideoTargetId",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Cena",
      field: "price",
      filter: "agNumberColumnFilter",
      width: 140,
    },
    {
      headerName: "Aktivan",
      field: "active",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      valueGetter: (params) => {
        if (params.data?.active === true) return "Aktivan";
        if (params.data?.active === false) return "Neaktivan";
        return "";
      },
    },
    {
      headerName: "Trajanje pristupa (dana)",
      field: "accessDuration",
      filter: "agNumberColumnFilter",
      width: 220,
    },
    {
      headerName: "Na prodaju",
      field: "shoppable",
      filter: "agSetColumnFilter",
      width: 140,
    },
    {
      headerName: "Na popustu",
      field: "discount",
      filter: "agSetColumnFilter",
      width: 140,
    },
    {
      headerName: "Besplatan",
      field: "free",
      filter: "agSetColumnFilter",
      width: 140,
    },
    {
      headerName: "Cena sa popustom",
      field: "discountPrice",
      filter: "agNumberColumnFilter",
    },
    createDateColumn("Popust od", "discountStart"),
    createDateColumn("Popust do", "discountEnd"),
    createDateColumn("Datum kreiranja", "createdAt"),
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={`${translateModule}${pageType}`}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        reloadData={() =>
          dispatch(fetchChannelList()).then(() => {
            toast.success("Podaci su uspešno osveženi", {
              theme: "colored",
            });
          })
        }
        rowData={channelList}
        columnDefs={columnDefs}
        buttonLink={`/channel-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey="channel-list"
      />
    </Fragment>
  );
};

export default ChannelList;
